import numberAlign from './numberAlign'
import textPopper from './textPopper'
import textHighlight from './textHighlight'
import copyText from './copyText'

export default {
    install(Vue) {
        numberAlign(Vue)
        textPopper(Vue)
        textHighlight(Vue)
        copyText(Vue)
    }
}
